import Button from '@leuven2030/framework/Button/Button';
import NavigationLink from '@leuven2030/framework/Navigation/NavigationLink';
import React from 'react';
import 'twin.macro';
import get from 'lodash/get';
const ContentAction = ({ data: { label, link } }) => {
  return (
    <NavigationLink prismicMeta={get(link, '_meta')}>
      <Button variant="contained" color="primary" tw="mx-auto">
        {label}
      </Button>
    </NavigationLink>
  );
};

ContentAction.type = 'action';

export default ContentAction;
